export default ({ request }) => ({

  prjTagListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/tag/list',
      method: 'post',
      data
    })
  },
  prjTagDetailApi (data = {}) {
    return request({
      url: '/digitalCenter/project/tag/detail',
      method: 'post',
      data
    })
  },
  prjTagSaveApi (data = {}) {
    return request({
      url: '/digitalCenter/project/tag/save',
      method: 'post',
      data
    })
  },
  prjTagDelApi (data = {}) {
    return request({
      url: '/digitalCenter/project/tag/del',
      method: 'post',
      data
    })
  }
})